import { makeStyles } from '@mui/styles'
import { colors } from '../../utils'

export const useSxStyles = () => {
  return {
    toggleGroup: {
      display: 'flex',
      margin: '20px 0',
      '& .MuiToggleButton-root': {
        flex: 1,
        background: colors.primary,
        '&:hover': {
          background: colors.primary + 'dd',
        },
        color: colors.white,
        '&.Mui-selected': {
          color: colors.white,
          background: colors.darkPrimary,
          '&:hover': {
            background: colors.darkPrimary + 'dd',
          },
        },
      },
    },
    submit: {
      width: 'fit-content',
      marginTop: '20px'
    },
    phone: {
      marginTop: '20px',
      width: '100%'
    }
  }
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'fixed',
    right: 0,
    top: 0,
    width: '40vw',
    minHeight: '100vh',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
    },
  },
  logo: {
    width: '33%',
    display: 'block',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '25%',
    },
  },
  gridChildren: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      width: '60%',
    },
  },
}))

export default useStyles
